import { useState, useEffect, useRef } from 'react';
import { useWindow } from './useWindow';
import { useDocument } from './useDocument';
const useHeaderMargin = () => {
    const [headerHeight, setHeaderHeight] = useState(0);
    const myWindow = useWindow();
    const myDocument = useDocument();
    const widthRef = useRef(null);
    useEffect(() => {
        if (!myDocument) {
            return;
        }
        const root = myDocument.documentElement;
        const headerEl = myDocument.getElementById('header');
        if (headerEl) {
            const headerOffsetHeight = headerEl.offsetHeight;
            root.style.setProperty('--header-height', headerOffsetHeight + 'px');
            setHeaderHeight(headerOffsetHeight);
        }
    }, [myDocument]);
    useEffect(() => {
        if (myWindow && myDocument) {
            const root = document.documentElement;
            const headerEl = document.getElementById('header');
            widthRef.current = myWindow.innerWidth;
            if (headerEl) {
                const handleResize = () => {
                    if (myWindow.innerWidth === widthRef.current) {
                        return;
                    }
                    widthRef.current = window.innerWidth;
                    const headerOffsetHeight = headerEl.offsetHeight;
                    root.style.setProperty('--header-height', headerOffsetHeight + 'px');
                    setHeaderHeight(headerOffsetHeight);
                };
                myWindow.addEventListener('resize', handleResize);
                return () => myWindow.removeEventListener('resize', handleResize);
            }
        }
    }, [myWindow, myDocument]);
    return { headerHeight };
};
export default useHeaderMargin;
